/**
 * Resolve patient display name for note output. Matches HeaderNoteInfo precedence:
 * navigation state (patient picker) → patient_plain_text → nested patient.
 */
export const getNotePatientNameParts = (note = {}, locationState = {}) => {
	const firstName =
		locationState?.first_name || note?.patient_plain_text?.first_name || note?.patient?.first_name || "";
	const lastName = locationState?.last_name || note?.patient_plain_text?.last_name || note?.patient?.last_name || "";
	return { firstName, lastName };
};

export const formatNotePatientFullName = (note = {}, locationState = {}) => {
	const { firstName, lastName } = getNotePatientNameParts(note, locationState);
	return [firstName, lastName].filter(Boolean).join(" ").trim();
};

/**
 * Merged patient fields for fillable PDF (`populatePdfForm`): same precedence as the note header —
 * `locationState` → `patient_plain_text` → nested `patient`. Splits combined `name` when needed.
 */
export const getPatientDataForFillablePdf = (note = {}, locationState = {}) => {
	const plain = note?.patient_plain_text || {};
	const pat = note?.patient || {};
	const loc = locationState || {};

	const pick = (key) => {
		if (loc[key] != null && String(loc[key]).trim() !== "") return loc[key];
		if (plain[key] != null && String(plain[key]).trim() !== "") return plain[key];
		if (pat[key] != null && String(pat[key]).trim() !== "") return pat[key];
		return "";
	};

	const { firstName, lastName } = getNotePatientNameParts(note, locationState);

	let first_name = firstName || pick("first_name");
	let last_name = lastName || pick("last_name");

	if (!String(first_name || "").trim() && !String(last_name || "").trim()) {
		const combined = plain.name || pat.name || loc.name;
		if (combined && String(combined).trim()) {
			const parts = String(combined).trim().split(/\s+/);
			first_name = parts[0] || "";
			last_name = parts.length > 1 ? parts.slice(1).join(" ") : "";
		}
	}

	return {
		...pat,
		...plain,
		first_name,
		last_name,
		email: pick("email") || pick("email_address"),
		mobile: pick("mobile") || pick("phone"),
		gender: pick("gender"),
		date_of_birth: pick("date_of_birth"),
		health_card_number: pick("health_card_number"),
		hc_version_code: pick("hc_version_code"),
		building: pick("building"),
		street: pick("street"),
		city: pick("city"),
		state: pick("state"),
		zip_code: pick("zip_code"),
		country: pick("country"),
		signature: pick("signature"),
		medicine: pick("medicine"),
	};
};
